import React, {
  Component, Fragment, useEffect, useState,
} from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Popover, Select } from 'antd';
import SelectTax from '@Components/Admin/Common/SelectTax';
import H3FormInput from '@Uilib/h3FormInput';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import './style.scss';
import { EditOutlined } from '@ant-design/icons';
import TallyIntegrationActions from '@Actions/integrations/tallyIntegrationActions';
import PRZSelect from '../UI/PRZSelect';

const { Option } = Select;
const ChargesTaxInput = ({
  chargesTaxId, setChargesTaxData, openChargesTax, setOpenChargesTax, sacCode, setSacCode, getTallyConnections,
  user, showTallyLedgerPurchase, getTallyConnectionsLoading, tallyLedgerName, setTallyLedgerName,
  selectedChargeName, showTallyLedgerSales, tallyConnections, selectedTenant, isVendorOverseas,
}) => {
  const itId = user?.user_tenants?.find((item) => item?.tenant_id === selectedTenant)?.it_id;
  useEffect(() => {
    const orgId = user?.tenant_info?.org_id;
    if (orgId && itId) {
      getTallyConnections(orgId, () => { }, itId);
    }
  }, [user, selectedTenant]);

  useEffect(() => {
    if (selectedChargeName && showTallyLedgerPurchase) {
      const matchingCharge = tallyConnections?.[0]?.purchase_charge_mappings?.find(
        (item) => item?.ledger_name === selectedChargeName,
      );
      if (matchingCharge) {
        setTallyLedgerName(matchingCharge?.ledger_account_name || null);
      } else {
        setTallyLedgerName(null);
      }
    } else if (selectedChargeName && showTallyLedgerSales) {
      const matchingCharge = tallyConnections?.[0]?.sales_charge_mappings?.find(
        (item) => item?.ledger_name === selectedChargeName,
      );
      if (matchingCharge) {
        setTallyLedgerName(matchingCharge?.ledger_account_name || null);
      } else {
        setTallyLedgerName(null);
      }
    }
  }, [selectedChargeName, tallyConnections]);
  return !isVendorOverseas && (
    <div className="charges-tax__wrapper">
      <Popover
        content={(
          <div>
            <div style={{ marginBottom: '10px' }} className="charges-tax__value">
              <SelectTax
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                onChange={(value) => {
                  setChargesTaxData(value);
                }}
                selectedGST={chargesTaxId}
                noTax
              />
            </div>
            <div className="charges-tax__value">
              <div className="orgInputContainer">
                <H3FormInput
                  name=""
                  type="number"
                  containerClassName="orgInputContainer"
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  placeholder=""
                  onChange={(event) => setSacCode(event.target.value)}
                  value={sacCode}
                  label="SAC Code"
                  maxlength="6"
                />
              </div>
            </div>
            {(showTallyLedgerPurchase || showTallyLedgerSales) && itId && (
              <div className="charges-tax__value">
                <div className="orgInputContainer">
                  <label
                    htmlFor="ledger-select"
                    style={{
                      display: 'block', marginBottom: '4px', fontSize: '13px', marginTop: '-5px',
                    }}
                  >
                    Ledger
                  </label>
                  <PRZSelect
                    onChange={(event) => {
                      setTallyLedgerName(event);
                    }}
                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    value={tallyLedgerName}
                    disabled={getTallyConnectionsLoading}
                    showSearch
                    allowClear
                    style={{
                      marginRight: '10px',
                    }}
                    id="ledger_account_name"
                    filterOption={(input, option) => option?.children.toLowerCase().includes(input.toLowerCase())}
                    placeholder=""
                  >
                    {tallyConnections?.[0]?.ledger_account_list?.map((item) => (
                      <Option value={item?.ledger_account_name} key={item?.ledger_account_name}>
                        {item?.ledger_account_name}
                      </Option>
                    ))}
                  </PRZSelect>
                </div>
              </div>
            )}
            <div className="charges-tax__footer">
              <H3Button
                text="Apply"
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                customClass="freight-tax__footer-submit"
                onClick={() => setOpenChargesTax(false)}
              />
            </div>
          </div>
        )}
        title={(
          <div className="charges-tax__title-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <div>Tax on Charges</div>
            <div>
              <H3Image
                src={closeIcon}
                className="charges-tax__close-icon"
                onClick={() => setOpenChargesTax(false)}
              />
            </div>
          </div>
        )}
        placement="bottomRight"
        trigger="click"
        open={openChargesTax}
        onOpenChange={() => setOpenChargesTax(!openChargesTax)}
      >
        <div onClick={() => {
          if (openChargesTax) {
            setOpenChargesTax(false);
          }
        }}
        >
          <EditOutlined />
          {chargesTaxId ? ' Edit' : ' Add'}
        </div>
      </Popover>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, TallyIntegrationReducers,
}) => ({
  user: UserReducers.user,
  tallyConnections: TallyIntegrationReducers.tallyConnections,
  getTallyConnectionsLoading: TallyIntegrationReducers.getTallyConnectionsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getTallyConnections: (orgId, callback, tallyId) => dispatch(TallyIntegrationActions.getTallyConnections(orgId, callback, tallyId)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ChargesTaxInput));
